import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './FieldMessage-hashed.scss';
import _ from 'lodash';
import cx from 'classnames';
import { defaultTheme } from '@elixir/theme';

/**
 * Class renders messages for `FieldComponent`.
 * Validation messages are expected to be translated before they are passed.
 */
export default class FieldMessage extends PureComponent {

    static propTypes = {
        /**
         * Error message to display
         */
        errorMessage: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
        /**
         * Success message to display
         */
        successMessage: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
        /**
         * Theme to apply to component
         */
        theme: PropTypes.object
    };

    static defaultProps = {
        theme: defaultTheme
    }

    render() {
        const { theme, errorMessage, successMessage } = this.props;
        const themeStyles = theme.getStyles('FieldMessage', styles);

        if (errorMessage) {
            return renderMessage(errorMessage, 'error', themeStyles);
        } else if (successMessage) {
            return renderMessage(successMessage, 'success', themeStyles);
        }
        return null;
    }
}

function renderMessage(message, key, themeStyles) {
    if (message) {
        const content = _.isFunction(message) ? message() : message;
        return <div key={key} className={cx(themeStyles.fieldMessage, themeStyles[key])}>{content}</div>;
    }
}
